export default __webpack_public_path__ + "static/media/apple-tv-default-screen.da4eb9e5.jpg";